import React, { useEffect, useState, createContext } from 'react'
import {
  Route,
  Routes,
  useLocation,
  useSearchParams,
  useNavigate
} from 'react-router-dom'
import { connect } from 'react-redux'

// pages
import Login from "./components/pages/Login"
import Mechanic from "./components/pages/Mechanic"
import Progress from "./components/pages/Progress"
import Awards from "./components/pages/Awards"
import Redemptions from "./components/pages/Redemptions"
import Terms from "./components/pages/Terms"
import Faqs from "./components/pages/Faqs"
import MajorAward from "./components/pages/MajorAward"
import NotFound from "./components/pages/NotFound"
import Landing from './components/pages/Landing'
import Onboarding from './components/pages/Onboarding'
// layout
import Header from "./layouts/Header/Header"
import Footer from "./layouts/Footer/Footer"

// components
import CustomModal from './components/molecules/CustomModal'
import { sendDataLayer } from './utils/functions'
// actions
import {
  logOutAction,
  loginShaAction
} from './store/sessionDuck'
import useWidth from './hooks/useWidth'

import {
  gtUser,
  gtStaticContent
} from './utils/helpers'
import { getPrice } from './utils/functions'
import { doRedeem } from './utils/helpers'

import './styles/main.scss'
import CustomModalLogin from './components/molecules/CustomModalLogin'

export const StateController = createContext(null)

function App({
  error,
  token,
  loggedIn,
  logOutAction
}) {
  const { width } = useWidth()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [modalOpen, setMdalOpen] = useState(false)
  const [notFound, setNotFound] = useState(false)
  const [endCampaign, setEndCampaign] = useState(false)
  const [context, setContext] = useState(false)
  const [staticContent, setStaticContent] = useState(false)
  const [autologinPreloader, setAutologinPreloader] = useState(false)

  const [awardSelected, setAwardSelected] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [redemtionLoading, setRedemtionLoading] = useState(false)
  const [showErrorRedemtion, setShowErrorRedemtion] = useState(false)
  const [showSuccessRedemtion, setShowSuccessRedemtion] = useState(false)
  const [showErrorDate, setShowErrorDate] = useState(false)
  const [twoStepString, setTwoStepString] = useState('')

  let home_page = '/GanaConMastercardDebit/onboarding'
  const pages = [
    { page: 'GanaConMastercardDebit/progreso', title: 'Progreso', icon: 'progress', sublevel: false, component: <Progress privatePage /> },
    { page: 'GanaConMastercardDebit/mecanica', title: 'Mecánica', icon: 'mechanic', sublevel: false, component: <Mechanic privatePage /> },
    { page: 'GanaConMastercardDebit/premios', title: 'e-Gift Cards', icon: 'catalog', sublevel: false, component: <Awards privatePage /> },

    { page: 'GanaConMastercardDebit/mis-redenciones', title: 'Canjes', icon: 'canjes', sublevel: false, component: <Redemptions privatePage /> },
    { page: 'GanaConMastercardDebit/premio-mayor', title: 'Premio mayor', icon: 'major-award', sublevel: false, component: <MajorAward privatePage /> },

    {
      page: 'mas', title: 'Más', icon: 'moremenu', sublevel: true, children: [
        { page: 'GanaConMastercardDebit/mis-redenciones', title: '', component: <Redemptions privatePage /> },
        { page: 'GanaConMastercardDebit/premio-mayor', title: 'Premio mayor', component: <MajorAward privatePage /> }
      ]
    }
  ]

  const pathURL = {
    "tZNsUTFTPw": "progreso",
    "WtwuqKUmjp": "mecanica",
    "JnXnducsYR": "premios",
    "MsFaj6v12C": "mis-redenciones",
    "pMLl7K7NL40": "premio-mayor",
    "dW01D9ysQJ7": "onboarding"
  }

  const closeLoginModal = () => {
    setAutologinPreloader(false)
    setNotFound(false)
    localStorage.removeItem('userNotFound')
    window.location.href = '/GanaConMastercardDebit'
  }

  useEffect(() => {
    if (localStorage.getItem('userNotFound')) {      
      setNotFound(true)

      setTimeout(() => {
        localStorage.removeItem('userNotFound')
      }, 3000)
    } else {
      setNotFound(false)
    }
  }, [location])

  useEffect(() => {
    if (searchParams.get('utm_web')) {
      setAutologinPreloader(true)
    }

    if (!localStorage.getItem('storage')) {
      if (window.location.search !== '') {
        console.log("Navegate to:", window.location.search)
        // navigate(window.location.search)
      } else {
        const public_url = pages.find((page) => page.page === location.pathname.replace('/', ''))
        const public_children_urls = pages.find((page) => page.sublevel)

        if (public_url) {
          if (!loggedIn && public_url?.component?.props?.privatePage) document.location.href = '/GanaConMastercardDebit'

        } else if (public_children_urls) {

          const public_child_url = public_children_urls?.children.find((childPage) => childPage.page === location.pathname.replace('/', ''))
          if (public_child_url?.component?.props?.privatePage) navigate('/GanaConMastercardDebit')
        }
      }
    }
  }, [searchParams, error])


  useEffect(() => {

    if (location.pathname === '/') {
      window.location.href = `/GanaConMastercardDebit/${location.search}`
    }
    if (location.pathname === '/preguntas-frecuentes') {
      window.location.href = `/GanaConMastercardDebit/preguntas-frecuentes`
    }
    if (location.pathname === '/terminos-y-condiciones') {
      window.location.href = `/GanaConMastercardDebit/terminos-y-condiciones`
    }


    if (token !== '') {
      gtUser(token).then((user) => {

        if (user) {

          if (user.data) {
            setContext(user.data)
            console.log("User data:", user.data, window.location.pathname, home_page)

            if (searchParams.get('pathurl')) {
              const path = pathURL[searchParams.get('pathurl')] || home_page
              let queryparams = ''

              for (const x of searchParams.keys()) {
                if (!(x === "utm_web" || x === 'pathurl')) {
                  queryparams += `${x}=${searchParams.get(x)}&`
                }
              }
              queryparams = queryparams.slice(0, queryparams.length - 1)
              window.location.href = `${path}${(queryparams && queryparams !== '') && '?'}${queryparams}`
            } else {
              if (window.location.pathname.toLowerCase() !== home_page.toLowerCase() && (window.location.pathname.toLowerCase() === '/ganaconmastercarddebit' || window.location.pathname.toLowerCase() === '/ganaconmastercarddebit/')) {
                if (
                  user?.data && 
                  !user?.data?.firstTime
                ) {
                  home_page = '/GanaConMastercardDebit/progreso';
                  window.location.href = home_page
                } else {
                  window.location.href = home_page
                }
              }
            }

            /*
            
              */

            if (user?.data?.tracing && user?.data?.tracing[`winner_${user.data.block}`] === 1) {
              // sendDataLayer({datalayer: { event: 'goal' },repeat: false})
              window.localStorage.setItem('goal', 'true')
            }

          } else if (user.detail && user.detail.includes('Database conection error.')) {
            console.log("Error en base de datos...", user)
            localStorage.removeItem('storage')
            window.location.reload()
          } else if (user.message && user.message.includes('nauthorized')) {
            console.log("No autorizado")
            localStorage.removeItem('storage')
            window.location.reload()
          }

        } else if (user.statusCode === 301 && localStorage.getItem('storage') && window.location.pathname === '/') {
          localStorage.removeItem('storage')
          window.location.reload()
        }
        if (user?.statusCode === 301 && window.location.pathname !== '/') {
          window.location.href = '/GanaConMastercardDebit'
        }
      }).catch(() => {
        // navigate('/')
      })

    }
  }, [token])

  useEffect(() => {

    gtStaticContent().then((content) => {
      if (content && content.content) setStaticContent(content.content)
    })
  }, [])

  // const handlerModal = () => {
  //   setShowConfirm(!showConfirm)

  // }
  const handlerModal = () => {
    if (showConfirm) {
      sendDataLayer({ datalayer: { event: 'cancel_bond', product_name: awardSelected.name, product_price: awardSelected.price, index: awardSelected.index }, repeat: true })
    }
    setShowConfirm(!showConfirm)

  }

  const handlerRedemtion = async () => {
    setRedemtionLoading(true)
    setShowErrorDate(false)
    let validator = false
    if (context && context.tracing && context.tracing.extra == twoStepString) {
      validator = true;
    }else if (context && context.tracing && context.tracing.extra !== twoStepString) {
      setTimeout(() => setShowErrorDate(true), 0)
      sendDataLayer({ datalayer: { event: 'error_bond', product_name: awardSelected.name, product_price: awardSelected.price }, repeat: true })
      setRedemtionLoading(false)
      return
    }

    if (awardSelected.canRedem) {
      if (validator) {
        doRedeem(token, awardSelected.price, awardSelected.id).then((data) => {
          setRedemtionLoading(false)
          setShowConfirm(false)

          if (data && data.status === 200 && data.file) {
            setShowSuccessRedemtion(true)
            sendDataLayer({ datalayer: { event: 'redeem_bond', product_name: awardSelected.name, product_price: awardSelected.price, index: awardSelected.index }, repeat: true })

            setTimeout(() => {
              window.location.href = '/GanaConMastercardDebit/mis-redenciones'
            }, 5000)
          } else {
            sendDataLayer({ datalayer: { event: 'exhausted_bond', product_name: awardSelected.name, product_price: awardSelected.price, index: awardSelected.index }, repeat: true })
            setShowErrorRedemtion(true)
          }
        }).catch(error => {
          console.log("ERROR ON REDENTION:", error)
        })
      } else {
        setRedemtionLoading(false)
        setShowConfirm(false)
        setShowErrorRedemtion(true)
        console.log("Validacion no completada.")
      }
    } else {
      setRedemtionLoading(false)
      setShowConfirm(false)
      setShowErrorRedemtion(true)
    }


  }

  return (
    <StateController.Provider
      value={
        {
          setMdalOpen: setMdalOpen,
          context: context,
          staticContent: staticContent,
          pages: pages,
          awardSelected: awardSelected,
          setAwardSelected: setAwardSelected,
          handlerRootModal: handlerModal
        }
      }
    >
      <CustomModalLogin
        title="Datos incorrectos"
        desc="Verifica tu información y vuelve a intentarlo."
        cta="Aceptar"
        icon={false}
        info_title=""
        primaryAction={
          {
            action: closeLoginModal,
            buttonText: 'Aceptar',
            loading: false
          }
        }
        show={notFound} setShowModal={setNotFound}
      />

      <CustomModal
        title="¡Esta campaña llegó a su fin!"
        desc="Pero la oportunidad de redimir tu gift card sigue vigente. ¡Descubre los bonos disponibles!"
        cta="Aceptar"
        icon={false}
        info_title=""
        general
        primaryAction={
          {
            action: setEndCampaign,
            buttonText: 'Aceptar',
            loading: false
          }
        }
        show={endCampaign} setShowModal={setEndCampaign}
      />
      {console.log("awardSelected", awardSelected)}

      <CustomModal
        show={showConfirm}
        setShowModal={setShowConfirm}
        image={awardSelected.image}
        title={`$ ${getPrice(awardSelected.price)}`}
        desc={awardSelected.name}
        twoStepAuth={true}
        redemtion={true}
        showErrorDate={showErrorDate}
        setTwoStepString={setTwoStepString}
        primaryAction={
          {
            action: handlerRedemtion,
            buttonText: "Descargar ",
            loading: redemtionLoading
          }
        }
        secondaryAction={
          {
            className: "cancel2",
            action: handlerModal,
            buttonText: "Cancelar2"
          }
        }
        terms={
          {
            termsText: "Términos y condiciones",
            termsLink: "/GanaConMastercardDebit/terminos-y-condiciones"
          }
        }
      />
      <CustomModal
        title={`¡Sigue participando por el premio mayor!`}
          desc={
              "Estas e-Gift Cards se han agotado.<br/>Sigue cumpliendo tu meta y suma oportunidades para ganar"
          }
          show={showErrorRedemtion} setShowModal={setShowErrorRedemtion}
          showErrorRedemtion={showErrorRedemtion}
          cta="Aceptar"
          isAwardTerms={true}
          winner={showErrorRedemtion}
          className="awards_modal"
      />
      <CustomModal
        title="Redención correcta"
        desc={`Tu bono ha sido descargado. Podrás encontrarlo en sección de canjes.`}
        cta="Aceptar"
        image="image.png"
        show={showSuccessRedemtion} setShowModal={setShowSuccessRedemtion}
        showSuccessRedemtion={showSuccessRedemtion}
        general
      />



      <div className={`App ${modalOpen ? 'modalOpen' : ''} ${loggedIn ? 'loggedIn' : 'noLoggedIn'}`}>
        <Header
          isLogin={(location.pathname.toLowerCase() === '/ganaconmastercarddebit' || location.pathname.toLowerCase() === '/ganaconmastercarddebit/') ? true : false}
          headerType={1}
          logo={width > 992 ? 'logo_desktop.svg' : 'header-mobile-logos-white.png'}
          items={pages}
          submenu={{
            type: "nickname",
            default: "A"
          }}
          notifications={
            [
              {
                id: 1,
                title: "Notification",
                content: "html content",
                status: 0
              }
            ]
          }
          loggedIn={loggedIn}
          logOutAction={logOutAction}
        />

        <Routes>
          <Route path="/GanaConMastercardDebit" element={<Login autologin={autologinPreloader} hash={searchParams.get('utm_web')} />} />
          <Route path="/GanaConMastercardDebit/landing" element={<Landing />} />
          <Route path="/GanaConMastercardDebit/onboarding" element={<Onboarding isLogin={location.pathname.toLowerCase() === '/ganaconmastercarddebit' || location.pathname.toLowerCase() === '/ganaconmastercarddebit/'} privatePage />} />
          <Route path="/GanaConMastercardDebit/terminos-y-condiciones" element={<Terms />} />
          <Route path="/GanaConMastercardDebit/preguntas-frecuentes" element={<Faqs />} />

          {/* Root pages */}
          {pages.map((page, i) => {
            return (
              <Route
                key={i}
                path={`/${page.page}`}
                element={page.component}
              />
            )
          })}

          {/* Child pages */}
          {pages.find((page) => {
            return page.sublevel ? true : false
          })?.children.map((page, i) => {
            return (
              <Route
                key={i}
                path={`/${page.page}`}
                element={page.component}
              />
            )
          })}
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer
          footerType={1}
          footerCardsImg="footer_cards.svg"
          secondaryFooterImg="footer_cards_ios.png"
          bankFooterImg="bank-footer.png"
          links={
            [
              {
                link: "/GanaConMastercardDebit/terminos-y-condiciones",
                text: "Términos y condiciones"
              },
              {
                link: "/GanaConMastercardDebit/preguntas-frecuentes",
                text: "Preguntas frecuentes"
              }
            ]
          }
          content="<p>Válido del 25 de septiembre hasta el 19 de noviembre de 2026</p><p>Aplica en compras realizadas dentro del territorio Ecuatoriano de manera presencial o por medios digitales, se incluyen las Apps de transporte, domicilios y streaming de audio y video.</p><p>Esta es una campaña oficial del Banco Guayaquil.</p><p>Tu privacidad es importante para nosotros. Por favor, revisa nuestra <a href='/assets/pdf/aviso_tratamiento_datos.pdf' target='_blank' rel='noopener noreferrer'>política de protección de datos</a> para entender cómo manejamos y protegemos tu información personal.</p>"
          copyright="Banco Guayaquil - Todos los derechos reservados 2026"
        />

      </div>
    </StateController.Provider>
  )
}

const mapState = ({ user: { fetching, loggedIn, token, error } }) => {
  return {
    fetching,
    loggedIn,
    token,
    error
  }
}

export default connect(mapState, { logOutAction, loginShaAction })(App)
